import { Component, EventEmitter, inject, Input, OnInit, Output } from "@angular/core";
import { Store } from "@ngrx/store";
import { select_MOUI_User } from "../state-management/mobi-office-ui.selector";
import { Observable, map } from "rxjs";
import { MatDialog, MatDialogConfig } from "@angular/material/dialog";
import { DialogService, GlobalService as MainGlobalService, StorageHandlerService } from "../services";
import { UserInfoSettingComponent } from "./user-info-setting/user-info-setting.component";
import { SocketClientService } from "../services/socket/socket.service";

enum PopOverElement {
  PROFILE_POPOVER_CLOSE_BTN = "close-profile-popover",
}

@Component({
  selector: "mobi-office-lib-header-section",
  templateUrl: "./header-section.component.html",
  styleUrls: ["./header-section.component.scss"],
  standalone: false,
})
export class HeaderSectionComponent implements OnInit {
  private readonly store = inject(Store);
  private readonly dialog = inject(MatDialog);
  private readonly dialogService = inject(DialogService);
  private readonly socketClientService = inject(SocketClientService);
  public readonly globalService = inject(MainGlobalService);
  private readonly storageHandlerService = inject(StorageHandlerService);

  constructor() {}

  ngOnInit(): void {
    this.socketClientService.removeUserLogin().subscribe((res: any) => {
      const existingToken = this.storageHandlerService.getItem("token");
      if (existingToken && res === existingToken) {
        this.logoutEmitter.emit();
      }
    });
  }

  @Input() isMagicBellVisible: boolean = false;
  @Input() isLogoVisible: boolean = true;
  @Input() isProfileVisible: boolean = true;
  @Input() externalMagicBellUserID: string = "";
  @Input() isProfileSettingVisible: boolean = false;
  @Input() isLogOutVisible: boolean = true;
  @Input() themeSwitcherVisible: boolean = false;

  @Output() logoutEmitter = new EventEmitter();
  @Output() logoClickEmitter = new EventEmitter();

  theme: boolean = false;

  get userInformation(): Observable<HeaderInfo> {
    return this.store.select(select_MOUI_User)?.pipe(
      map(user => {
        const tempModal: HeaderInfo = {
          ApplicationInfo: {},
          UserInfo: {},
          RoleName: "",
          Roles: [],
        };

        if (user?.UserInfo) {
          tempModal.ApplicationInfo = user.UserInfo.Application || {};
          tempModal.UserInfo = user.UserInfo.UserInfo || {};
          tempModal.RoleName = user?.UserInfo?.Roles?.map((el: any) => el.Name)?.join(",");
          tempModal.Roles = user?.UserInfo?.Roles;
        }

        return tempModal;
      })
    );
  }

  private closeProfilePopover() {
    const CLOSE_BTN = document.getElementById(PopOverElement.PROFILE_POPOVER_CLOSE_BTN) as HTMLButtonElement;
    if (CLOSE_BTN) CLOSE_BTN.click();
  }

  UserSettingsDialog() {
    this.closeProfilePopover();
    const dialogConfig = new MatDialogConfig();
    this.dialogService.matDialogDefaultConfig(dialogConfig);
    dialogConfig.width = "60%";
    const dialogRef = this.dialog.open(UserInfoSettingComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(res => {});
  }

  onLogOut() {
    this.closeProfilePopover();
    this.logoutEmitter.emit();
  }

  onClickLogo() {
    this.logoClickEmitter.emit();
  }

  onThemeChange(theme: "dark" | "white") {
    this.globalService.changeTheme(theme);
  }
}

interface HeaderInfo {
  ApplicationInfo: any;
  UserInfo: any;
  RoleName: string;
  Roles: any[];
}
